import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Page, Select, ListHorizontal, DatePicker } from 'ui/components';

import { Journal } from 'services/action';

import Table from './component/table.config';
import { currencyFormat, formatDate } from 'utilities/common';

const initialState = {
  data: null,
  coa: null,
  periode: {
    default: new Date(),
    formatted: formatDate(new Date(), 'YYYY-MM'),
  },
};

const LedgerScreen = () => {
  const Dispatch = useDispatch();
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Journal.GetLedger']
  );

  const [{ data, coa, periode }, setState] =
    React.useState(initialState);

  const $onLoad = async() => {
    let data = null
    const result = await Dispatch(Journal.$getLedger({coa_id: coa?.id, periode: periode?.formatted}));

    if (result?.message === 'success') {
      data = result?.data
    }

    setState((prevState) => ({...prevState, data: data}));
  }

  React.useEffect(() => {
    $onLoad();
  }, [coa, periode]);

  return (
    <Page>
      <Page.Header
        pretitle="Daftar"
        title={'Buku Besar'}
        isLoading={StateLoading}
      />

      <div className='row bg-white px-2 m-0 pt-2'>
        <div className='col-md-3'>
          <div className="mb-3">
            <label class="form-label fs-8">Pilih Coa</label>
            <Select.Remote
              placeholder=""
              url="/accounting/coa"
              value={coa?.id}
              initialValue={coa?.id}
              row={(d) => {
                return {
                  value: d?.id,
                  label: d?.code,
                };
              }}
              onSelected={(e) =>
                setState((prevState) => ({...prevState, coa: e}))}
            />
          </div>

          <div className="mb-3">
            <label class="form-label fs-8">Pilih Periode</label>
            <DatePicker
              selectionMode="month"
              value={periode?.default || null}
              format="yyyy/MM"
              onChange={(e) => {
                setState((prevState) => ({...prevState, periode: { default: e, formatted: formatDate(e, 'YYYY-MM') }}))
              }}
              isShowTrigger
            />
          </div>
        </div>

        {coa && (
          <div className='col-md-4 pt-3'>
            <ListHorizontal title="Nama Akun" content={coa?.name} />
            <ListHorizontal title="Jumlah Debit" content={data? currencyFormat(data?.summary?.total_debit) : '-'} />
            <ListHorizontal title="Jumlah Kredit" content={data ? currencyFormat(data?.summary?.total_credit) : '-'} />
          </div>
        )}

        {/* <div className={`px-3 ${coa ? 'col-md-5': 'col-md-9'}`}>
          <div className="d-flex table-tools align-items-end justify-content-end h-100">
            <div className="d-flex align-items-center">
              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip id={`tooltip-top`}>Download XLS</Tooltip>}
              >
                <Button
                  variant="dark"
                  className="ms-2"
                  onClick={$handleDownload}
                  style={{ height: 30 }}
                >
                  <HiOutlineCloudDownload size={18} color="white" />
                </Button>
              </OverlayTrigger>
            </div>
          </div>
        </div> */}
      </div>

      <Page.Body className="row border-top">
        <Table data={data} />
      </Page.Body>
    </Page>
  );
};

export default LedgerScreen;